import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-picture",
  "use": "icon-picture-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-picture\">\n  <defs></defs>\n  <path d=\"M 14.42 10.9 L 18.6 16.4 L 5.4 16.4 L 8.7 12.11 L 11.01 15.08 L 14.2 10.9 L 14.42 10.9 Z M 8.15 10.9 C 9.03 10.9 9.8 10.13 9.8 9.25 C 9.8 8.37 9.03 7.6 8.15 7.6 C 7.27 7.6 6.5 8.37 6.5 9.25 C 6.5 10.13 7.27 10.9 8.15 10.9 Z M 23 5.4 L 23 18.6 C 23 19.81 22.01 20.8 20.8 20.8 L 3.2 20.8 C 1.99 20.8 1 19.81 1 18.6 L 1 5.4 C 1 4.19 1.99 3.2 3.2 3.2 L 20.8 3.2 C 22.01 3.2 23 4.19 23 5.4 Z M 20.8 8.48 L 20.8 5.4 L 3.2 5.4 L 3.2 18.6 L 20.8 18.6 L 20.8 8.48 Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/picture.svg
// module id = b5ZH
// module chunks = 262